import { deleteSettingsTelegramApiTokenApi as generatedDeleteSettingsTelegramApiTokenApi } from '../generated/settingsCommunicationChannels/deleteSettingsTelegramApiToken';

const deleteSettingsTelegramApiTokenApi = generatedDeleteSettingsTelegramApiTokenApi.enhanceEndpoints({
  endpoints: {
    deleteSettingsTelegramApiToken: {
      invalidatesTags: ['SettingsCommunicationChannels'],
    },
  },
});

export const { useDeleteSettingsTelegramApiTokenMutation } = deleteSettingsTelegramApiTokenApi;
